import React, { useState, useEffect } from 'react';
import './navbar.css';
import { useLocation } from "react-router-dom";
import axios from "axios";
//import DatePicker from "react-datepicker";
//import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
//import Ditta_Form_Base from "./Ditta_form_base";

import { Navigate } from 'react-router-dom';
//import NavScrollExample from "../component_auth0/Navbar_new";
import Progetto_valutazione_form_base from "./Progetto_valutazione_form_base.jsx";


const Progetto_form_valutazione_dalla_mail = () => {

   
    const search = useLocation().search;
    const attore = new URLSearchParams(search).get('attore');
    const id = new URLSearchParams(search).get('id');
    const indice = new URLSearchParams(search).get('indice');
    const valore = new URLSearchParams(search).get('valore');

    const [show, setShow] = useState(true);
    const [progetto, SET_progetto] = useState({});
   

    // the alert is displayed by default
    const [show_alert, setAlert] = useState(false);

    useEffect(() => {
        console.log('+++++ USEEFFECT +++++')
        console.log('Siamo in Progetto form valutazione')

        //        setTimeout(() => {
        //            setAlert(false);
        //        }, 3000);
        //        let history = useHistory();
        axios.get('/progetti/trova_progetto/' + id)
        .then((res) => {
            console.log('/progetti/trova_progetto/')
            //            console.log(res.data)
            console.log(res.data)
 
            SET_progetto(res.data)
        }).catch((error) => {
            console.log(error)
        });

 
    }, []);


    function Mostra_alert() {
        if (show_alert) {
            return <div class="alert alert-success" role="alert">
                This is a success alert with <a href="#" class="alert-link">an example link</a>. Give it a click if you like.
            </div>
        }
        if (!show) {
            console.log('sadgsdfgdsfgsdfgdsfgds')

            return <Navigate to="/url_form_ditta_uscita_form" replace={true} />

        }
    }


    return (
        <>
    
            <div>
                {/* <p>{id} - {attore} - {indice} - {valore} </p> */}
                  {Mostra_alert()}
            </div>
            <div>
                <Progetto_valutazione_form_base progetto={progetto}     setShow={setShow} />
       
              </div >
        </>
    );
}
export default Progetto_form_valutazione_dalla_mail;